// components/PrivateComponent.tsx
"use client";
import { useState, useEffect } from "react";
import { useRouter, usePathname } from "next/navigation";
import { PrivateComponentProps } from "types";
import { useAppContext } from "hooks";

const PrivateComponent: React.FC<PrivateComponentProps> = ({ redirectTo, children }) => {
  const [isMounted, setIsMounted] = useState(false);
  const router = useRouter();
  const pathname = usePathname();
  const { jwt, profile, isLoading } = useAppContext();
  const [isVerified, setIsVerified] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  useEffect(() => {
    if (!isMounted) {
      return;
    }

    if (!jwt) {
      router.replace(redirectTo);
      return;
    }

    if (isLoading) {
      return;
    }

    if (!profile || !profile.email) {
      router.replace(redirectTo);
      return;
    }

    if (pathname === "/admin" || pathname.startsWith("/admin/")) {
      if (profile.role.name !== "admin") {
        router.replace(redirectTo);
        return;
      }
    }

    setIsVerified(true);
  }, [isMounted, jwt, pathname, isLoading, profile]);

  if (!isVerified) return <></>;
  return <>{children}</>;
};

export default PrivateComponent;
